INPUT_VALUE_DEFINITION